"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = Footer;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var sc = _interopRequireWildcard(require("./Footer.styles"));

var propTypes = {
  children: _propTypes["default"].node.isRequired,
  height: _propTypes["default"].number,
  isSticky: _propTypes["default"].bool
};
var defaultProps = {
  height: 72,
  isSticky: false
};

function Footer(props) {
  var children = props.children,
      moreProps = (0, _objectWithoutProperties2["default"])(props, ["children"]);
  return /*#__PURE__*/_react["default"].createElement(sc.Footer, (0, _extends2["default"])({
    "data-pka-anchor": "panel.footer"
  }, moreProps), children);
}

Footer.propTypes = propTypes;
Footer.defaultProps = defaultProps;
Footer.displayName = "Panel.Footer";
//# sourceMappingURL=Footer.js.map